import { methodGet, methodPost, methodDelete, methodPut, methodPatch } from './methods';
import api from './api';
import { API_INFO } from '../constants';

export const getCategories = async () => {
  return methodGet(API_INFO + 'company/gallery/categories');
};

export const getGallery = async () => {
  return methodGet(API_INFO + 'company/gallery');
};

export const getActivities = async (payload) => {
  const url = API_INFO + `company/schedules/`;
  return methodGet(url, payload);
};

export const getEvents = async (query) => {
  return methodGet(API_INFO + 'company/events/', query);
};

export const getEvent = async (id) => {
  return methodGet(API_INFO + `company/events/${id}/`);
};

export const getCountries = async (query) => {
  return methodGet(API_INFO + 'company/countries/', query);
};
export const getCountry = async (id) => {
  return methodGet(API_INFO + `company/countries/${id}/`);
};

export const getLanguages = async (query) => {
  return methodGet(API_INFO + 'company/languages/', query);
};

export const getBookStores = async (payload) => {
  return methodGet(API_INFO + 'company/companies/', payload);
};

export const getAllBookStores = async (payload) => {
  return methodGet(API_INFO + 'company/companies/all-companies/', payload);
};

export const getLibraryDetail = async (id) => {
  return methodGet(`${API_INFO}company/companies/${id}`);
};

export const createBookStore = async (payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(API_INFO + 'company/companies/', payload, config);
};

export const editBookStore = async (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `company/companies/${id}/`, payload, config);
};

export const companyConfiguration = async (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `company/companies/configuration/`, payload, config);
};

export const getDetailBookStore = async (id) => {
  return methodGet(API_INFO + `company/companies/${id}/`);
};

export const deleteBookStore = async (id) => {
  return methodDelete(API_INFO + `company/companies/${id}/`);
};

export const getLocalities = async (query) => {
  return methodGet(API_INFO + `company/localities/`, query);
};
export const getLocality = async (id) => {
  return methodGet(API_INFO + `company/localities/${id}/`);
};

export const getMetadataCompany = async () => {
  return methodGet(API_INFO + 'company/metadata-company/');
};

export const getProvinces = async (params) => {
  return methodGet(API_INFO + 'company/provinces/', params);
};

export const getProvince = async (id) => {
  return methodGet(API_INFO + `company/provinces/${id}/`);
};

export const getLocalitiesByProvince = async (params) => {
  return methodGet(API_INFO + 'company/localitiesByProvince/', params);
};

export const getCSData = async () => {
  return methodGet(API_INFO + 'company/coffee-shop');
};

export const getBookingForm = async (params) => {
  return methodGet(`${API_INFO}user/reservation/send/`, params);
};

export async function postSubscriptionEmail(payload) {
  const url = API_INFO + 'company/subscription/';
  return methodPost(url, payload);
}

export const getAllListSubscription = async (payload) => {
  const url = API_INFO + `company/subscription/`;
  return methodGet(url, payload);
};

export const deleteSubscription = async (id) => {
  const url = API_INFO + `company/subscription/${id}`;
  return methodDelete(url);
};

export const exportSubscriptions = async (payload = {}) => {
  const url = API_INFO + 'company/subscription/export_subscriptions/';
  try {
    const { status, data, headers } = await api.post(url, {}, {
      params: payload,
      responseType: 'blob',
    });
    return { status, data, headers };
  } catch (error) {
    return {
      status: error.response?.status ?? 500,
      data: error.response?.data ?? null,
      headers: error.response?.headers ?? {},
    };
  }
};

export const getAllSchedules = async (payload) => {
  const url = API_INFO + `company/schedules/`;
  return methodGet(url, payload);
};

export const createSchedule = async (payload) => {
  const url = API_INFO + `company/schedules/`;
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(url, payload, config);
};

export const editSchedule = async (payload, id) => {
  const url = API_INFO + `company/schedules/${id}/`;
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(url, payload, config);
};

export const getDetailSchedule = async (id) => {
  const url = API_INFO + `company/schedules/${id}`;
  return methodGet(url);
};

export const deleteSchedule = async (id) => {
  return methodDelete(API_INFO + `company/schedules/${id}/`);
};

export const getAllRelatedSchedule = async (id) => {
  return methodGet(API_INFO + `company/schedules/${id}/related/`);
};

export const getTypeSchedules = async (query) => {
  const url = API_INFO + 'company/type-schedules/';
  return methodGet(url, query);
};

export const getTypeSchedulesNotPaginated = async (query) => {
  return methodGet(API_INFO + 'company/type-schedules/type-schedules-not-paginated', query);
};

export const getDetailTypeSchedule = async (id) => {
  const url = API_INFO + `company/type-schedules/${id}`;
  return methodGet(url);
};

export const createTypeSchedule = async (payload) => {
  const url = API_INFO + 'company/type-schedules/';
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(url, payload, config);
};

export const editTypeSchedule = async (payload, id) => {
  const url = API_INFO + `company/type-schedules/${id}/`;
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(url, payload, config);
};

export const deleteTypeSchedule = async (id) => {
  return methodDelete(API_INFO + `company/type-schedules/${id}/`);
};

export const getTextLegalPrivacyNotice = async () => {
  return methodGet(API_INFO + `company/text-legal-privacy-notice/`);
};

export const getTextCookies = async () => {
  return methodGet(API_INFO + `company/text-cookie/`);
};

export const getTextTermsUse = async () => {
  return methodGet(API_INFO + `company/text-terms-use/`);
};

export const getCompaniesLibraries = async (query) => {
  return methodGet(API_INFO + 'company/companies/', query);
};

export const getHelpText = async (payload) => {
  return methodGet(API_INFO + `company/help-text/`, payload);
};

export async function createHelpText(payload) {
  const url = API_INFO + 'company/help-text/';
  return methodPost(url, payload);
}

export const editHelpText = async (id, payload) => {
  return methodPatch(API_INFO + `company/help-text/${id}/`, payload);
};

export const deleteHelpText  = async (id) => {
  return methodDelete(API_INFO + `company/help-text/${id}/`);
};

export const getHelpTextId = async (id) => {
  return methodGet(API_INFO + `company/help-text/${id}/`);
};

export const getDeliveries = async (payload) => {
  return methodGet(API_INFO + 'transport/province-limited-deliveries/', payload);
};

export async function createDelivery(payload) {
  const url = API_INFO + 'transport/province-limited-deliveries/';
  return methodPost(url, payload);
}

export const editDelivery = async (id, payload) => {
  return methodPatch(API_INFO + `transport/province-limited-deliveries/${id}/`, payload);
};

export const getDetailDelivery = async (id) => {
  return methodGet(API_INFO + `transport/province-limited-deliveries/${id}/`);
};

export const deleteDelivery = async (id) => {
  return methodDelete(API_INFO + `transport/province-limited-deliveries/${id}/`);
};

export async function createMenu(payload) {
  const url = API_INFO + 'company/companies/update-menu/';
  return methodPost(url, payload);
}

export const getMenuCategory = async (payload) => {
  return methodGet(API_INFO + 'utils/categories-menu/', payload);
};

export const getCategoryMenuNotPaginated = async (query) => {
  return methodGet(API_INFO + 'utils/categories-menu/category-menu-not-paginated', query);
};

export async function createMenuCategory(payload) {
  const url = API_INFO + 'utils/categories-menu/';
  return methodPost(url, payload);
}

export const editMenuCategory = async (id, payload) => {
  return methodPatch(API_INFO + `utils/categories-menu/${id}/`, payload);
};

export const deleteMenuCategory = async (id) => {
  return methodDelete(API_INFO + `utils/categories-menu/${id}/`);
};

export const getDetailMenuCategory = async (id) => {
  return methodGet(API_INFO + `utils/categories-menu/${id}/`);
};

export const getMateriasIbic = async (payload) => {
  return methodGet(API_INFO + 'books/materias-ibic/', payload);
};

export const getMateriasIbicMain = async (payload) => {
  return methodGet(API_INFO + 'books/materias-ibic/get-main/', payload);
};

export const getMateriasIbicAll = async (payload) => {
  return methodGet(API_INFO + 'books/materias-ibic/all-materies/', payload);
};

export const getTermsOfUse = async (payload) => {
  return methodGet(API_INFO + 'company/text-terms-use/', payload);
};

export const getCookiePolicy = async (payload) => {
  return methodGet(API_INFO + 'company/text-cookie/', payload);
};

export const getLegalPrivacyNotice = async (payload) => {
  return methodGet(API_INFO + 'company/text-legal-privacy-notice/', payload);
};

export async function createTermsOfUse(payload) {
  const url = API_INFO + 'company/text-terms-use/';
  return methodPost(url, payload);
}

export async function createCookiePolicy(payload) {
  const url = API_INFO + 'company/text-cookie/';
  return methodPost(url, payload);
}

export async function createLegalPrivacyNotice(payload) {
  const url = API_INFO + 'company/text-legal-privacy-notice/';
  return methodPost(url, payload);
}

export const updateTermsOfUse = async (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `company/text-terms-use/${id}/`, payload, config);
};

export const updateLegalPrivacyNotice = async (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `company/text-legal-privacy-notice/${id}/`, payload, config);
};

export const updateCookiePolicy = async (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `company/text-cookie/${id}/`, payload, config);
};

export const getSettingCompany = async () => {
  return methodGet(API_INFO + 'company/settings/', {});
};

export const createAffiliate = async (payload) => {
  return methodPost(API_INFO + `company/affiliation-request/`, payload)
}

export async function postLibraryRating(payload) {
  const url = API_INFO + 'company/rating-library/';
  return methodPost(url, payload);
}

export async function postLibraryComment(payload) {
  const url = API_INFO + 'company/comment-library/';
  return methodPost(url, payload);
}

export const editLibraryComment = async (id, payload) => {
  return methodPatch(API_INFO + `company/comment-library/${id}/`, payload);
}

export async function getServicesActives(payload) {
  const url = API_INFO + 'company/services/actives/';
  return methodGet(url, payload);
}

export const getAffiliationRequest = async (payload) => {
  return methodGet(API_INFO + `company/affiliation-request/`, payload);
};

export async function createAffiliation(payload) {
  const url = API_INFO + 'company/affiliation-request/';
  return methodPost(url, payload);
}

export const editAffiliation = async (id, payload) => {
  return methodPatch(API_INFO + `company/affiliation-request/${id}/`, payload);
};

export const deleteAffiliation = async (id) => {
  return methodDelete(API_INFO + `company/affiliation-request/${id}/`);
};

export const getAffiliationId = async (id) => {
  return methodGet(API_INFO + `company/affiliation-request/${id}/`);
};

export const getAwardWinningBooks = async (payload) => {
  return methodGet(API_INFO + 'premio/premio/', payload);
};

export const editAwardWinningBook = async (id, payload) => {
  return methodPatch(API_INFO + `premio/premio/${id}/`, payload);
};

export const deleteAwardWinningBook = async (id) => {
  return methodDelete(API_INFO + `premio/premio/${id}/`);
};

export const getAwardWinningBookById = async (id) => {
  return methodGet(API_INFO + `premio/premio/${id}/`);
};

export const createAwardWinningBook = async (payload) => {
  return methodPost(API_INFO + 'premio/premio/', payload);
};

export const getActivitiesByLibraryId = async (id) => {
  const url = `${API_INFO}company/schedules/company/${id}/`;
  return methodGet(url);
};

// Endpoints para temas
export const getThemes = async () => {
  return methodGet(API_INFO + 'company/themes/');
};

export const createTheme = async (payload) => {
  return methodPost(API_INFO + 'company/themes/', payload);
};

export const updateTheme = async (id, payload) => {
  return methodPatch(API_INFO + `company/themes/${id}/`, payload);
};

export const deleteTheme = async (id) => {
  return methodDelete(API_INFO + `company/themes/${id}/`);
};